import { combineReducers, Reducer } from 'redux';
import { reducer as assortmentReducer } from 'b2b-apps/shop/assortment/redux/assortment/reducer';
import { reducer as ownAssortmentReducer } from 'b2b-apps/shop/assortment/redux/ownAssortment/reducer';

const reducer: Reducer = combineReducers({
  mainAssortment: assortmentReducer,
  ownAssortment: ownAssortmentReducer,
});

export {
  reducer,
};
